import { useMemo } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { buildPlans } from '#/data/plans'
import PlanCard from './PlanCard'
import { usePlans } from '../hooks/usePlans'

export default function PlansList() {
  const { data: apiPricing } = usePlans()

  const plans = useMemo(() => {
    return buildPlans(apiPricing || {})
  }, [apiPricing])

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 items-stretch">
      <AnimatePresence mode="popLayout">
        {plans.map((plan, i) => (
          <motion.div
            key={plan.id}
            layout
            initial={{ opacity: 0, y: 24, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.97 }}
            transition={{
              duration: 0.35,
              delay: i * 0.08,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="flex w-full"
          >
            <PlanCard plan={plan} />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  )
}
